module.exports = __webpack_public_path__ + "assets/b7334300bab04d459da9d036ba444771.svg";